module.exports = __webpack_public_path__ + "gp.svg?8fc39c39ffec8d93e550676fec3b8b56";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/gp.svg
// module id = 1128
// module chunks = 0